import styles from './guidBasic.module.css';
import ReactQuill from 'react-quill';
import DirectInput from '../../../directInput/DirectInput';
import { modules } from '../../../../utils/quillModules';
import { formats } from '../../../../utils/quillFormats';
import CharCount from '../../../charCount/CharCount';
import TimePicker from '../../../reusable-ui-components/TimePicker';
import useSectionHighlightRef from '../../../../hooks/useSectionHighlightRef';
import { forwardRef } from 'react';

const GuidBasic = forwardRef(({ guidData, setGuidData, isEdit, isSupport }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    return (
        <div ref={sectionRef}>
            {isEdit ? <h1 className='orgPackUpH1'>Edit Giude</h1> : <h1 className='orgPackUpH1'>Create New Giude</h1>}
            <div className={styles.orgPackUpSecDiv}>
                <DirectInput
                    label='Title'
                    name='title'
                    value={guidData.title}
                    type='text'
                    placeholder='Title'
                    setFormData={setGuidData}
                    min={3}
                    limit={50}
                    disabled={!isSupport && isEdit && guidData.status !== 'inactive' && guidData.status !== 'rejected'}
                    error={highlightField === 'title'}
                />
                <div className={styles.guidDiv}>
                    <label className={styles.guidLabel}>Overview</label>
                    <div className={styles.guidDescDiv}>
                        <ReactQuill
                            name='overview'
                            value={guidData.overview}
                            onChange={(event) =>
                                setGuidData((prevState) => ({
                                    ...prevState,
                                    overview: event
                                }))
                            }
                            theme='snow'
                            placeholder='Overview'
                            className={`${highlightField === 'overview' ? 'error-highlight' : ''}`}
                            readOnly={isEdit && guidData.status !== 'inactive' && guidData.status !== 'rejected'}
                            modules={modules}
                            formats={formats}
                        />
                        <CharCount string={guidData.overview} min={50} limit={4000} />
                    </div>
                </div>
                <div className={`${styles.timeSlotsInDiv}`}>
                    <label className={styles.guidLabel}>Opening Time</label>
                    <div className={styles.timeSlotsInputDiv}>
                        <TimePicker
                            value={guidData.openTime}
                            onChange={(getTimeValue) => {
                                setGuidData((prev) => ({
                                    ...prev,
                                    openTime: getTimeValue
                                }));
                            }}
                            error={highlightField === 'openTime'}
                        />
                    </div>
                </div>
                <div className={styles.timeSlotsInDiv}>
                    <label className={styles.guidLabel}>Closing Time</label>
                    <div className={styles.timeSlotsInputDiv}>
                        <TimePicker
                            value={guidData.closeTime}
                            onChange={(getTimeValue) => {
                                setGuidData((prev) => ({
                                    ...prev,
                                    closeTime: getTimeValue
                                }));
                            }}
                            error={highlightField === 'closeTime'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default GuidBasic;
